import { all, takeLatest, call, put } from 'redux-saga/effects';
import Axios, { AxiosResponse } from 'axios';
import { verifyInviteTokenSuccess, verifyInviteTokenFailure } from './actions';
import { WelcomeActionTypes } from './types';
import { verifyInviteToken } from 'services/auth.service';

function* handleVerifyInviteToken(request: any) {
  try {
    const response: AxiosResponse = yield call(
      verifyInviteToken,
      request.payload
    );
    if (response) {
      yield put(verifyInviteTokenSuccess());
    }
  } catch (err) {
    const msg = Axios.isAxiosError(err) ? err.response?.data?.msg : undefined;
    yield put(verifyInviteTokenFailure(msg || 'Unable to verify invite token'));
  }
}

function* watchVerifyInviteToken() {
  yield takeLatest(
    WelcomeActionTypes.VERIFY_INVITE_TOKEN_START,
    handleVerifyInviteToken
  );
}

function* sagas() {
  yield all([call(watchVerifyInviteToken)]);
}

export default sagas;
